import { render } from "./tab-groups.vue?vue&type=template&id=7bdcf2b4"
import script from "./tab-groups.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-groups.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/history/history-card/components/tab-groups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bdcf2b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bdcf2b4', __exports__)) {
    api.reload('7bdcf2b4', __exports__)
  }
  
  module.hot.accept("./tab-groups.vue?vue&type=template&id=7bdcf2b4", () => {
    api.rerender('7bdcf2b4', render)
  })

}


export default __exports__